<template>
	<PayAudioLibraryShell
		:data="data"
		:block-id="blockId"
		:editable="editable"
		:active="active"
		:h5="h5"
		:compact="compact"
		@select="$emit('select')"
	/>
</template>

<script>
	import PayAudioLibraryShell from '../shared/PayAudioLibraryShell.vue';

	export default {
		name: 'GBlockPayAudioLibrary',
		components: { PayAudioLibraryShell },
		props: {
			data: {
				type: Object,
				required: true,
			},
			blockId: {
				type: String,
				default: '',
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			compact: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
	};
</script>
